import { Button, styled } from "@mui/material";

export const SetButton: any = styled(Button)({
    width: "100%",
    padding: "0 30px",
    height: "48px",
    color: "#fff",

    backgroundColor: "#3D76EF",
    "&:hover": {
        backgroundColor: "#3D76EF",
    },
    "&:disabled": {
        color: "#FFFFFF",
        backgroundColor: "#707070",
    },
})